export default{
    increment(state){
        state.counter = state.counter +2;
    },
    increase(state, payload){
        //payload는 넘겨받는 인자값으로 string 이나 number 모두 올수 있다.
        state.counter = state.counter + payload.value;
    },
}
